import { Component, OnInit } from '@angular/core';
import { DownloadService } from 'src/app/shared/services/download.service';
import { UserService } from 'src/app/shared/services/user.service';
import {Router} from '@angular/router';
import {IWGSharedService} from '../../shared/services/shared.service';
import {CommonService} from '../../shared/services/common.service';
import { NavbarService } from 'src/app/shared/services/navbar.service';

@Component({
  selector: 'app-worker-profile-detail',
  templateUrl: './worker-profile-detail.component.html',
  styleUrls: ['./worker-profile-detail.component.scss']
})
export class WorkerProfileDetailComponent implements OnInit {

  isLoading = true;
  state = {};
  WorkerName: any;
  WorkerDisplayName :any;
  WorkerInformation = null;
  ResumeFileGUID:any;
  hasWorkerProfile:boolean;

  constructor(private userService: UserService, private download: DownloadService, private nav: NavbarService,
              private router: Router, private sharedService: IWGSharedService, private common: CommonService
  ) { }

  ngOnInit(): void {
    this.nav.show();
    this.nav.setActiveMenu('my-talent');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'my-talent'});

      this.hasWorkerProfile = this.userService.hasWorkerProfile();
      this.WorkerName = this.userService.getLoggedInName();
      this.WorkerDisplayName = this.userService.getWorkerDisplayName();
      this.common.getWorkerProfile().subscribe((workerDetails: any) => {
          workerDetails = workerDetails.data.Data;
          this.WorkerInformation = workerDetails;
          this.ResumeFileGUID = workerDetails.ResumeFileGUID;
          this.isLoading = false;
      });

      this.sharedService.HasWorkerProfile.subscribe((data) => { 
        this.hasWorkerProfile = data;
      });
  }

  downloadResume() {
    this.download.saveAs('/Api/File/' + this.ResumeFileGUID).then(() => {
    });
  }
  OnClick = (redirectUrl) => {
        this.router.navigate([redirectUrl]);
  }
  DeleteProfile = () => {
    if (this.WorkerInformation && this.WorkerInformation.WorkerProfileID > 0) {
        if (confirm('Are you sure you want to delete worker profile ?')) {
            // Do it!
            let props = {
                worker_profile_id: this.WorkerInformation.WorkerProfileID
            };
            let prom = this.common.DeleteWorkerProfile( props).toPromise();
            prom.then(this.onSuccessDeleteWorkerProfile.bind(this), this.onWorkerProfileDeleteError.bind(this));
        } else {
            // Do nothing!

        }
    }
  }
    onSuccessDeleteWorkerProfile() {
      this.sharedService.HasWorkerProfile.next(false);
      this.router.navigate(['worker-profile']);
    }
    onWorkerProfileDeleteError() {

    }
    OnClickMyTalent = () => {
        if (this.hasWorkerProfile == true) {
            this.router.navigate(['worker-profile-detail']);
        } else {
            this.router.navigate(['worker-profile']);
        }
    }

}
